/**
 * @param {import('@supabase/supabase-js').User} user
 */
export function displayNameFromUser(user) {
  const meta = user.user_metadata ?? {};
  const full = typeof meta.full_name === "string" ? meta.full_name.trim() : "";
  if (full) return full;
  const name = typeof meta.name === "string" ? meta.name.trim() : "";
  if (name) return name;
  const email = user.email?.trim();
  if (email) return email.split("@")[0] || email;
  return "Player";
}

/**
 * @param {import('@supabase/supabase-js').User} user
 * @returns {string | null}
 */
export function avatarUrlFromUser(user) {
  const meta = user.user_metadata ?? {};
  const raw =
    (typeof meta.avatar_url === "string" && meta.avatar_url) ||
    (typeof meta.picture === "string" && meta.picture) ||
    "";
  const url = raw.trim();
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  return null;
}

/**
 * @param {import('@supabase/supabase-js').SupabaseClient} supabase
 * @param {import('@supabase/supabase-js').User} user
 */
export async function upsertProfile(supabase, user) {
  const { error } = await supabase.from("profiles").upsert({
    id: user.id,
    display_name: displayNameFromUser(user),
    avatar_url: avatarUrlFromUser(user),
    updated_at: new Date().toISOString(),
  });
  if (error) {
    console.warn("profile upsert failed", error.message);
  }
}
